<div class="page-body">
  <div *ngIf="error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">{{ translations.errorHeading }}</p>
      <p class="info-text">
        {{ translations.errorInfo }}
      </p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          class="error-button"
          [text]="translations.backButton"
          (click)="handleCancellation()"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div *ngIf="!state.currentPageInformation.homePage" class="banner">
      <button type="button" class="back-button" (click)="handleCancellation()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">{{
        translations.cancellationButton
      }}</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <app-zaver-icon class="icon-user-img" [size]="80" name="bankSignalCircle"></app-zaver-icon>
        <h1 class="heading">
          {{ translations.heading }}
        </h1>

        <div class="info-text">
          {{ translations.subHeading }}
        </div>

        <div class="footer-wrapper">
          <div class="footer-container">
            <div class="button-container">
              <zaver-primary-button
                [text]="translations.continueButton"
                [disabled]="navigationInProgress || loading || authInProgress"
                [loading]="authInProgress"
                (click)="handleCtaClick()"
              ></zaver-primary-button>
            </div>

            <p
              *ngIf="state.currentPageInformation.homePage"
              class="disclaimer-paragraph"
            >
              {{ translations.disclaimerPartOne }}
              <a
                class="disclaimer-link"
                target="_blank"
                [href]="translations.linkTermsOfUse"
                >{{ translations.disclaimerPartTwo }}</a
              >{{ translations.disclaimerPartThree }}
              <a
                class="disclaimer-link"
                target="_blank"
                [href]="translations.linkPrivacyPolicy"
                >{{ translations.disclaimerPartFour }}</a
              >
              {{ translations.disclaimerPartFive }}
              <a
                class="disclaimer-link no-wrap"
                target="_blank"
                [href]="translations.linkCookies"
                >{{ translations.disclaimerPartSix }}</a
              >{{ translations.disclaimerPartSeven
              }}<a
                *ngIf="state.checkoutCustomizations.merchantTermsUrl"
                class="disclaimer-link"
                target="_blank"
                [href]="state.checkoutCustomizations.merchantTermsUrl"
                >{{ getPartEightDisclaimer() }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
